import { ICartItem } from "store/types/cartTypes";

export const ITEM_TYPES = {
    PRODUCTS: "products",
    PRODUCT_GROUP: "product_groups",
} as const;

/**
 * Determines if an item is a kit
 * Checks both the itemType field and the presence of product_group_items
 * @param item - Cart item or product object
 * @returns true if item is a kit, false otherwise
 */
export const isKit = (item: ICartItem | any): boolean => {
    if (!item) return false;
    return item.itemType === ITEM_TYPES.PRODUCT_GROUP || (Array.isArray(item.product_group_items) && item.product_group_items.length > 0);
};

/**
 * Gets the item type
 * @param item - Cart item or product object
 * @returns 'products' | 'product_groups'
 */
export const getItemType = (item: ICartItem | any): typeof ITEM_TYPES[keyof typeof ITEM_TYPES] => {
    return isKit(item) ? ITEM_TYPES.PRODUCT_GROUP : ITEM_TYPES.PRODUCTS;
};

/**
 * Gets the appropriate route for an item
 * @param item - Cart item or product object
 * @returns Route path for the item
 */
export const getItemRoute = (item: ICartItem | any): string => {
    return isKit(item) ? `/kit/${item.id}` : `/product/${item.id}`;
};

/**
 * Gets the display label for an item type
 * @param item - Cart item or product object
 * @returns 'product_groups' or 'products'
 */
export const getItemTypeLabel = (item: ICartItem | any): string => {
    return isKit(item) ? ITEM_TYPES.PRODUCT_GROUP : ITEM_TYPES.PRODUCTS;
};

/**
 * Maps frontend itemType to backend API expected values
 * Unified by ITEM_TYPES constant
 */
export const mapItemTypeToBackend = (itemType?: string): typeof ITEM_TYPES[keyof typeof ITEM_TYPES] => {
    if (itemType === ITEM_TYPES.PRODUCT_GROUP) {
        return ITEM_TYPES.PRODUCT_GROUP;
    }
    return ITEM_TYPES.PRODUCTS;
};

/**
 * Maps backend itemType to frontend values
 * Unified by ITEM_TYPES constant
 */
export const mapItemTypeFromBackend = (backendType?: string): typeof ITEM_TYPES[keyof typeof ITEM_TYPES] => {
    if (backendType === ITEM_TYPES.PRODUCT_GROUP) {
        return ITEM_TYPES.PRODUCT_GROUP;
    }
    return ITEM_TYPES.PRODUCTS;
};


